import React from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ExamTitle from './ExamTitle'
import ExamQuestionHeader from './ExamQuestionHeader';
import ExamQuestion from './ExamQuestion'
import ExamAnswers from './ExamAnswers'

const useStyles = makeStyles(theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      backgroundColor: 'unset',
      width: '100%',
      height: '100%',
      padding: '24px 0',
      'justify-content': 'center',
      'align-items': 'flex-start',
      'overflow': 'auto',
      '@media (max-width: 1050px)': {
        padding: 0
      },
      '& > *': {
        margin: theme.spacing(1),
        width: '100%',
        minHeight: '280px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      },
      skipButton: {
        '@media(max-width: 1050px)': {
          width: '100%'
        }
      }
    }
  })
)

const QuestionBlock = styled.div`
  padding: 32px 32px 8px;
  &.isQuestion {
    background-color: #f2f2f2;
  }
`

const AnswersBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px 32px;
  margin-top: 16px
`

const ExamStructure = ({ content, loading, type, questionNumber, goToNextQuestion, onChange, selectedAnswer, handleSelectedAnswer, answerList, questionLoading }) => {
    const classes = useStyles();
    let currentQuestion = ((content || {}).perguntas || [])[questionNumber]
    const examType = (content || {}).__typename


    const handleChangeAnswer = (id) => {
      onChange({
        pergunta: currentQuestion._id,
        resposta: id
      })
    }

    if ((currentQuestion || {}).respostas) {
      currentQuestion.respostas = ((currentQuestion || {}).respostas || []).map(resposta => {
        if(resposta._id === answerList[currentQuestion._id]) {
          return {...resposta, selected: true}
        }
          return {...resposta, selected: false}
      })
    }

    const value = (((currentQuestion || {}).respostas || []).find(item => (item || {}).selected) || {})._id || null

     return (
      <div className={classes.root}>
        <Paper>
          <QuestionBlock className={questionNumber > -1 ? 'isQuestion' : ''}>
            <ExamTitle type={(type || {})} description={(content || {}).descricao}/>
            <ExamQuestionHeader content={content} questionNumber={questionNumber} currentQuestion={currentQuestion} testInfo={content} type={type} description=''/>
            {!questionLoading && <ExamQuestion loading={questionLoading} questionContent={currentQuestion}/>}
          </QuestionBlock>
          <AnswersBlock >
            <ExamAnswers questionLoading={questionLoading} answersContent={currentQuestion} examType={examType} onChange={handleChangeAnswer} answerList={answerList} value={value}/>
          </AnswersBlock>
        </Paper>
      </div>
    )
}

export default ExamStructure